import React from "react";
import moment from "moment";
import "../../../../css/page/content/ticket/Ticket.css";
import "moment/locale/fr";
import stringTools from "../../../../class/tool/StringTools";
import StringTools from "../../../../class/tool/StringTools";
import SaleController from "../../../../stories/_operation/Sale/SaleController";
moment.locale("fr");

const TicketV2 = props => {
    const { sale } = props;
    const LOG = false;

    const convert = () => {
        return <div className="ticket">
            { header() }
            { recapTotal() }
            { details() }
            { subTotal() }
        </div>
    }
    const header = () => {
        return <div className={"header"}>
            <p>{ sale.socialReason }</p>
            <p>{ sale.address + ", " + sale.postalCode + " " + sale.city }</p>
            <p>Visité le { moment.utc(sale.created_at).local().format("DD/MM/YYYY à HH:mm:ss") }</p>
            <p>Ticket nº{ sale.number }</p>
        </div>;
    }
    const recapTotal = () => {
        return <div className={"recapTotal"}>
            <p>Total réglé</p>
            <p className={"amount"}>{ stringTools.number_format(sale.amountInclTax, 2, ",", " ") }<span>€</span></p>
            <p className={"article"}>{ sale.nbArticle } article{ (sale.nbArticle > 1 ? "s" : "") }</p>
        </div>;
    }
    const details = () => {
        return <table className={"details"}>
            <thead>
                <tr>
                    <th className={"center"}>Qte</th>
                    <th className={"name"}>Article</th>
                    <th className={"right amount"}>Montant</th>
                </tr>
            </thead>
            <tbody>
            {
                sale.kart.contents.map((article, index) => content(article, index))
            }
            </tbody>
        </table>;
    }
    const content = (article, index) => {
        if (LOG) console.log("article", article);
        const discountValue = SaleController._ParseFloat(article.discountValue);
        const lineDiscountAmount = article.discountTotalAmount !== undefined ? SaleController._ParseFloat(article.discountTotalAmount) : 0;
        let valueDiscount = "";

        if (article.discountType !== null && article.discountType !== "") {
            switch (article.discountType) {
                case "PERCENT":
                    valueDiscount = stringTools.number_format(discountValue, 0, ",", " ") + " %";
                    break;
                case "DEVISE":
                    valueDiscount = stringTools.number_format(discountValue, 2, ",", " ") + " EUR";
                    break;
                case "OFFERED":
                    valueDiscount = "OFFERT";
                    break;
                default: break;
            }
        }

        return <tr key={index} className={"content"}>
            <td className={"center"}>{ stringTools.number_format(article.quantity, 0, ",", " ") }</td>
            <td className={"name"}>
                { StringTools.capitalizeFirstLetter(article.productName.toLocaleLowerCase()) }
                {
                    valueDiscount.length > 0
                    && <span className={"discount"}>Remise { valueDiscount } soit { stringTools.number_format(lineDiscountAmount, 2, ",", " ") } €</span>
                }
            </td>
            <td className={"right amount"}>{ stringTools.number_format(article.amountInclTax, 2, ",", " ") } €</td>
        </tr>
    }
    const subTotal = () => {
        if (LOG) console.log("sale", sale);
        return <div className={"subTotal"}>
            <div className={"line space"}>
                <p className={"label high blue"}>Total</p>
                <p className={"value high blue"}>{ stringTools.number_format(sale.amountInclTax, 2, ",", " ") } €</p>
            </div>
            {
                discountSale()
            }
            {
                sale.kart.payments.map((pay, index) => payment(pay, index))
            }
            {
                sale.kart.vats.map((tax, index) => vat(tax, index))
            }
            {
                sale.kart.vats.length > 1
                && <div className={"line"}>
                    <p className={"label"}>Montant TVA</p>
                    <p className={"value"}>{ stringTools.number_format(sale.amountTax !== 0 ? sale.amountTax : sale.kart.amountTax, 2, ",", " ") } €</p>
                </div>
            }
            <div className={"line"}>
                <p className={"label"}>Total HT</p>
                <p className={"value"}>{ stringTools.number_format(sale.amountExclTax !== 0 ? sale.amountExclTax : sale.kart.amountExclTax, 2, ",", " ") } €</p>
            </div>
        </div>;
    }
    const discountSale = () => {
        if (sale.kart.discountType === null || sale.kart.discountType === "")
        if (sale.kart.discountType === null || sale.kart.discountType === "")
            return;

        const kartDiscountValue = SaleController._ParseFloat(sale.kart.discountValue);
        const kartLineDiscountAmount = SaleController._ParseFloat(sale.kart.lineDiscountAmount);
        const kartSaleDiscountAmount = SaleController._ParseFloat(sale.kart.saleDiscountAmount);
        const kartAmountInclTaxUndiscounted = SaleController._ParseFloat(sale.kart.amountInclTaxUndiscounted);

        let valueDiscount = ""

        switch (sale.kart.discountType) {
            case "PERCENT":
                valueDiscount = kartDiscountValue.toFixed() + " %";
                break;
            case "DEVISE":
                valueDiscount = kartDiscountValue.toFixed(2).replace('.', ',') + " EUR";
                break;
            case "OFFERED":
                valueDiscount = "OFFERT";
                break;
            default: break;
        }

        return <>
            <div className={"line"}>
                <p className={"label"}>Montant Hors Remise</p>
                <p className={"value"}>{ stringTools.number_format(kartAmountInclTaxUndiscounted + kartLineDiscountAmount, 2, ",", " ") } €</p>
            </div>
            <div className={"line"}>
                <p className={"label"}>Remise {valueDiscount} soit</p>
                <p className={"value"}>{ stringTools.number_format(kartSaleDiscountAmount, 2, ",", " ") } €</p>
            </div>
        </>;
    }
    const payment = (payment, index) => {
        if (LOG) console.log("payment", payment);
        const theoricalAmount = SaleController._ParseFloat(payment.theoricalAmount)
        const paymentAmount = SaleController._ParseFloat(payment.amount)

        return <div key={index} className={"blockLine"}>
            <div className={"line"}>
                <p className={"label"}>{ payment.paymentMethodName }</p>
                <p className={"value"}>{ stringTools.number_format(payment.theoricalAmount, 2, ",", " ") } €</p>
            </div>
            {
                theoricalAmount !== paymentAmount
                && <div className={"line"}>
                    <p className={"label"}>Rendu monnaie</p>
                    <p className={"value"}>{ stringTools.number_format((theoricalAmount - paymentAmount) * -1, 2, ",", " ") } €</p>
                </div>
            }
        </div>;
    }
    const vat = (tax, index) => {
        if (LOG) console.log("vat", tax);
        return <div key={index} className={"line"}>
            <p className={"label"}>Taux TVA { tax.vatRateName.replace(".", ",").replace("%", " %") }</p>
            <p className={"value"}>{ stringTools.number_format(tax.amountTax, 2, ",", " ") } €</p>
        </div>;
    }

    return(convert());
}

export default TicketV2;
